import { BusinessRulesTypeEnum } from '../../enums/businessRulesTypes.enum';
import { RuleTypeText } from '../../interfaces/ruleTypeText.interface';

export class BusinessRulesHelper {
  public static readonly blockRulesTypes = [
    BusinessRulesTypeEnum.BLOCK_CUSTOMER_IN_DEBT,
    BusinessRulesTypeEnum.BLOCK_WINBACK,
    BusinessRulesTypeEnum.BLOCK_OFFER_WITH_LOWER_RANK_MAIN_SERVICES,
    BusinessRulesTypeEnum.BLOCK_OFFER_WITH_OWNED_SERVICES,
    BusinessRulesTypeEnum.BLOCK_MIGRATION,
    BusinessRulesTypeEnum.BLOCK_OFFER_WITH_SHORTER_COMMITMENT_LENGTH,
    BusinessRulesTypeEnum.BLOCK_OFFER_WITH_PREMIUMS_WITH_START_DISCOUNT_MONTHS
  ];

  public static readonly lengthRulesTypes = [
    BusinessRulesTypeEnum.EOP_LENGTH,
    BusinessRulesTypeEnum.MAX_WINBACK_INACTIVE_LENGTH,
    BusinessRulesTypeEnum.BLOCK_MIGRATION_ON_DISCOUNT_PERIOD_START
  ];

  public static setRuleTypeText(type): RuleTypeText {
    switch (type) {
      case BusinessRulesTypeEnum.EOP_LENGTH:
        return {
          title: 'BUSINESS_RULES_HELPER.EOP_LENGTH.TITLE',
          describe: 'BUSINESS_RULES_HELPER.EOP_LENGTH.DESCRIBE',
          label: 'BUSINESS_RULES_HELPER.EOP_LENGTH.LABEL'
        };
      case BusinessRulesTypeEnum.MAX_WINBACK_INACTIVE_LENGTH:
        return {
          title: 'BUSINESS_RULES_HELPER.MAX_WINBACK_INACTIVE_LENGTH.TITLE',
          describe: 'BUSINESS_RULES_HELPER.MAX_WINBACK_INACTIVE_LENGTH.DESCRIBE',
          label: 'BUSINESS_RULES_HELPER.MAX_WINBACK_INACTIVE_LENGTH.LABEL'
        };
      case BusinessRulesTypeEnum.BLOCK_MIGRATION_ON_DISCOUNT_PERIOD_START:
        return {
          title: 'BUSINESS_RULES_HELPER.BLOCK_MIGRATION_ON_DISCOUNT_PERIOD_START.TITLE',
          describe: 'BUSINESS_RULES_HELPER.BLOCK_MIGRATION_ON_DISCOUNT_PERIOD_START.DESCRIBE',
          label: 'BUSINESS_RULES_HELPER.BLOCK_MIGRATION_ON_DISCOUNT_PERIOD_START.LABEL'
        };
      case BusinessRulesTypeEnum.BLOCK_WINBACK:
        return {
          title: 'BUSINESS_RULES_HELPER.BLOCK_WINBACK.TITLE',
          describe: 'BUSINESS_RULES_HELPER.BLOCK_WINBACK.DESCRIBE'
        };
      case BusinessRulesTypeEnum.BLOCK_CUSTOMER_IN_DEBT:
        return {
          title: 'BUSINESS_RULES_HELPER.BLOCK_CUSTOMER_IN_DEBT.TITLE',
          describe: 'BUSINESS_RULES_HELPER.BLOCK_CUSTOMER_IN_DEBT.DESCRIBE'
        };
      case BusinessRulesTypeEnum.BLOCK_MIGRATION:
        return {
          title: 'BUSINESS_RULES_HELPER.BLOCK_MIGRATION.TITLE',
          describe: 'BUSINESS_RULES_HELPER.BLOCK_MIGRATION.DESCRIBE'
        };
      case BusinessRulesTypeEnum.BLOCK_OFFER_WITH_LOWER_RANK_MAIN_SERVICES:
        return {
          title: 'BUSINESS_RULES_HELPER.BLOCK_OFFER_WITH_LOWER_RANK_MAIN_SERVICES.TITLE',
          describe: 'BUSINESS_RULES_HELPER.BLOCK_OFFER_WITH_LOWER_RANK_MAIN_SERVICES.DESCRIBE'
        };
      case BusinessRulesTypeEnum.BLOCK_OFFER_WITH_SHORTER_COMMITMENT_LENGTH:
        return {
          title: 'BUSINESS_RULES_HELPER.BLOCK_OFFER_WITH_SHORTER_COMMITMENT_LENGTH.TITLE',
          describe: 'BUSINESS_RULES_HELPER.BLOCK_OFFER_WITH_SHORTER_COMMITMENT_LENGTH.DESCRIBE'
        };
      case BusinessRulesTypeEnum.BLOCK_OFFER_WITH_OWNED_SERVICES:
        return {
          title: 'BUSINESS_RULES_HELPER.BLOCK_OFFER_WITH_OWNED_SERVICES.TITLE',
          describe: 'BUSINESS_RULES_HELPER.BLOCK_OFFER_WITH_OWNED_SERVICES.DESCRIBE'
        };
      case BusinessRulesTypeEnum.BLOCK_OFFER_WITH_PREMIUMS_WITH_START_DISCOUNT_MONTHS:
        return {
          title: 'BUSINESS_RULES_HELPER.BLOCK_OFFER_WITH_PREMIUMS_WITH_START_DISCOUNT_MONTHS.TITLE',
          describe: 'BUSINESS_RULES_HELPER.BLOCK_OFFER_WITH_PREMIUMS_WITH_START_DISCOUNT_MONTHS.DESCRIBE'
        };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/business-rules/business-rules-helper.ts